import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';
import styled, { inputImages, inputNumbers, inputStyles } from '../../Utils/inputChanges';
import { partyInwMenu } from '../TitleList';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { createItemEntry, fetchItemData, insertItemMaterial } from '../../Store/PHPSlice/Item';
import { selectBrandlist, selectItems, selectParty } from '../Selectors/Master/ItemSelectors';
import { fetchBrandData } from '../../Store/PHPSlice/Rack';
import Dropdown from '../FieldsComponents/Dropdown';
import TitleBar from '../TitleBar';
import { fetchMaterialData } from '../../Store/PHPSlice/Material';
import { selectMaterials } from '../Selectors/Master/OutwardSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchPartyInwMemo, insertPartyInward } from '../../Store/PHPSlice/PartyInward/PartyInwApi';
import { selectPartyInwMemo } from '../Selectors/Master/MasterSelectors';
import { Preview } from '@mui/icons-material';

const PartyInward = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [material, setMaterial] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [multiData, setMultiData] = useState([]);
    const [itemQty, setItemQty] = useState({
        size: [],
        qty: []
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        party: fetchPartyData,
        brand: fetchBrandData,
        item: fetchItemData,
        material: fetchMaterialData
        // Add more mappings if needed
    };
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();

    const itemlist = useSelector(selectItems);
    const brandlist = useSelector(selectBrandlist);
    const materiallist = useSelector(selectMaterials);
    const partylist = useSelector(selectParty);
    const piMemo = useSelector(selectPartyInwMemo);
    // const memo = piMemo?.data?.memo || '';
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        pino: '',
        pino2: '',
        party: '',
        item: '',
        itemNm: '',
        brand: '',
        material: [],
        totqty: '',
        totmat: '',
        size: '',
        userId: userdata?.userId,
        multot: ''
    });
    useEffect(() => {
        // console.log(piMemo , ' pimemo');
        if(piMemo?.data === undefined || piMemo?.data === null || piMemo?.data.length === 0){
            dispatch(fetchPartyInwMemo());
        }

        if(material && material.length === 0){
            dispatch(fetchMaterialData());
        }

        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (piMemo?.data) {
            const memo = piMemo?.data?.memo;
            setFormData(prev => ({
                ...prev,
                pino: memo,
                pino2: memo
            }));
        }
    }, [piMemo]);

    const handleDropdownChange = (e, dropdownType) => {
        const { value, name } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (name) {
            case 'item':
                if (value) {
                    const selectItems = itemlist?.data?.find(val => val.ID === value);
                    let itemNm = selectItems?.itemNm;
                    let sizearr = selectItems?.size?.split(",");
                    let size = `${sizearr[0]}-${sizearr[sizearr.length - 1]}`;
                    setFormData(prev => ({
                        ...prev,
                        size: size,
                        itemNm: itemNm
                    }));
                    setItemQty({
                        size: sizearr,
                        qty: Array(sizearr.length).fill(0)
                    });
                }
                break;

        }

    };

    const handleDropdownChange2 = (matIndex, newValue) => {
        setMaterial((prevMaterials) => {
            const updatedMaterials = [...prevMaterials];
            if (!updatedMaterials[matIndex]) return updatedMaterials;

            // Update the specific material name
            updatedMaterials[matIndex] = {
                ...updatedMaterials[matIndex],
                material: newValue?.ID || '',
                materialNm: newValue?.materialNm || ''
            };
            return updatedMaterials;
        });
    };


    const handlenavigateparty = () => {
        window.open(`/new-party-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handlenavigatebrand = () => {
        window.open(`/new-brand-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handlenavigateItem = () => {
        window.open(`/new-item-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handlenavigateMaterial = () => {
        window.open(`/new-material-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };


    const isDesktop = useMediaQuery('(min-width:768px)');

    const dropdownlistfirst = [
        {
            label: 'Party',
            id: 'party',
            options: Array.isArray(partylist?.data) ? partylist?.data : [],
            value: formData.party,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'party', value: newValue ? newValue.ID : '' } }, 'party'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: handlenavigateparty,
        },
        {
            label: 'Brand',
            id: 'brand',
            options: Array.isArray(brandlist?.data) ? brandlist?.data : [],
            value: formData.brand,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'brand', value: newValue ? newValue.ID : '' } }, 'brand'),
            getOptionLabel: (option) => option.brandNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: handlenavigatebrand,
        },
        {
            label: 'Item',
            id: 'item',
            options: Array.isArray(itemlist?.data) ? itemlist?.data : [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: handlenavigateItem,
        }
    ];


    const handleLumpColor = (index, value, name) => {
        const updatematerial = [...material];
        updatematerial[index][name] = value;
        setMaterial(updatematerial);
        const totmtqty = updatematerial.reduce((acc, qty) => acc + parseFloat(qty.qty), 0);
        setFormData(prev => ({
            ...prev,
            totmat: totmtqty || 0
        }));
    };

    const handleAddlump = () => {
        const materialdata = {
            ID: 0,
            materialNm: '',
            qty: '',
            selected: false
        };
        setMaterial((prevRows) => [...prevRows, materialdata]);
        setFormData(prev => ({
            ...prev,
            material: ''
        }));
    };

    const handleLumpSelection = (index) => {
        const newRows = [...material];
        newRows[index].selected = !newRows[index].selected;
        setMaterial(newRows);
    };

    const handleRemoveLumps = () => {
        const filteredRows = material.filter((row) => !row.selected);
        setMaterial(filteredRows);

        // const totmtr = filteredRows.reduce((acc, mtr) => acc + parseFloat(mtr.mtr), 0);
        // setLumpTotMtr(totmtr);
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
        if (name === 'totqty') {
            setItemQty((prevItemQty) => {
                return {
                    ...prevItemQty,
                    qty: Array(itemQty?.size?.length).fill(0)
                };
            });


        }
    };


    const handleItemQtyChange = (e, index) => {
        const { value } = e.target;

        // Compute the updated qty array
        const updatedQty = itemQty.qty.map((qtyVal, qtyIndex) =>
            qtyIndex === index ? value : qtyVal // Update only the index that matches
        );

        // Calculate the sum using the updated qty array
        const sumtot = updatedQty.reduce((acc, qty) => acc + parseFloat(qty || 0), 0);

        // Update the itemQty state
        setItemQty(prev => ({
            ...prev,
            qty: updatedQty
        }));

        // Update the formData state
        setFormData(prev => ({
            ...prev,
            totqty: sumtot
        }));
    };


    function postObj(formData, multiData) {
        const data = {
            dt: formData.dt,
            piMemo: formData.pino,
            piMemo2: formData.pino2,
            partyId: formData.party,
            brandId: formData.brand,
            multiData: multiData,
            userId: formData.userId
        };
        return data;
    };

    function postObj2(formData, material, itemQty) {
        const data = {
            itemId: formData.item,
            itemNm: formData.itemNm,
            totqty: formData.totqty,
            totmtqty: formData.totmat,
            material: material,
            size: itemQty.size,
            qty: itemQty.qty,
            selected: false
        };
        return data;
    };

    const handleAddClick = () => {
        const postdata = postObj2(formData, material, itemQty);
        setMultiData(prev => [...prev, postdata]);
        const updateMultiData = [...multiData];
        // const tot = updateMultiData?.reduce((acc, val) => acc + parseFloat(val.totqty));
        console.log(updateMultiData);
        setFormData(prev => ({
            ...prev,
            item: '',
            itemNm: '',
            totqty: '',
            totmat: '',
            // multot: tot
        }));

        setMaterial([]);
        setItemQty({
            size: [],
            qty: []
        });
    };

    const handleMultiDataSelection = (index) => {
        const newRows = [...multiData];
        newRows[index].selected = !newRows[index].selected;
        setMultiData(newRows);
    };

    const handleRemoveMultiData = () => {
        const filteredRows = multiData?.filter((row) => !row.selected);
        setMultiData(filteredRows);
    };

    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/party-inward-view?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };
    // console.log(multiData);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.pino || formData.pino === '') {
            alert("Enter Party Ref. no is required.");
            return; // Stop the submission if validation fails
        }

        const postdata = postObj(formData, multiData);
        // console.log(postdata); 
        dispatch(insertPartyInward(postdata))
            .unwrap()
            .then((result) => {
                console.log('POST request successful!', result);
                // toast.success("Item Added");
                alert("Record Added");
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error while making POST request:', error);
            });
    };

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Party Ref No.', name: 'pino' }
    ];

    const fields2 = [
        { label: 'Total Qty.', name: 'totqty' }
    ];
    const fields3 = [
        { label: 'Item Size', name: 'size', type: 'readOnly' }
    ];


    return (
        <>
            <TitleBar data={partyInwMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Party Inward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1.2}>

                                {fields.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}
                                            handleDropdownOpen={handleDropdownOpen}  // Pass `valueFinder` function here
                                            handleDropdownClose={handleDropdownClose}
                                            handleAddNew={drop.handleAddNew}
                                        />
                                    ))
                                }

                                {fields3.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}
                                
                                {/* {
                                    dropdownlistsecond && dropdownlistsecond.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                } */}

                                <Grid item xs={12} md={6}></Grid>
                                {fields2.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                <Grid item xs={12} md={6}>
                                    <div>
                                        {/* <h3>Material Entry </h3> */}
                                        <div className="button-group">
                                            <button className="add" onClick={handleAddlump}>Add</button>
                                            <button className="delete" onClick={handleRemoveLumps}>Remove</button>
                                            <button className="add" onClick={handlenavigateMaterial}>New Material</button>
                                        </div>
                                        <table style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Material Work</th>
                                                    <th>Qty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {material.map((mat, matIndex) => (
                                                    <>
                                                        <tr key={matIndex}>
                                                            <td><input
                                                                type="checkbox"
                                                                checked={mat.selected}
                                                                onChange={() => handleLumpSelection(matIndex)}
                                                            />{" "}
                                                                {matIndex + 1}
                                                            </td>
                                                            <td>
                                                                <DropdownWithBtn
                                                                    key={matIndex}
                                                                    id={matIndex} // Unique ID for each material
                                                                    options={materiallist?.data || []}
                                                                    value={mat.material} // Bind value dynamically
                                                                    onChange={(newValue) =>
                                                                        handleDropdownChange2(matIndex, newValue) // Pass matIndex and dropdown id
                                                                    }
                                                                    isDesktop={isDesktop}
                                                                    getOptionLabel={(option) => option.materialNm || ''}
                                                                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                                    valueFinder={(options, value) => {
                                                                        if (Array.isArray(options)) {
                                                                            return options.find(item => item.ID === value) || null;
                                                                        }
                                                                        return null;
                                                                    }}
                                                                    handleDropdownOpen={handleDropdownOpen}  // Pass `valueFinder` function here
                                                                    handleDropdownClose={handleDropdownClose}
                                                                />

                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    placeholder="qty"
                                                                    value={mat.qty}
                                                                    onChange={(e) => handleLumpColor(
                                                                        matIndex,
                                                                        e.target.value,
                                                                        "qty"
                                                                    )}
                                                                />
                                                            </td>


                                                        </tr>
                                                    </>
                                                ))}
                                                <tr>
                                                    <td> </td>
                                                    <td>
                                                        <span className="tot-lump">Total Qty</span>
                                                    </td>
                                                    <td>
                                                        <span className="tot-lump">{formData.totmat}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <div>
                                        <table style={{ width: '100%' }}>
                                            <tbody>
                                                <tr>
                                                    <td>Size</td>
                                                    {itemQty?.size?.map((val, valIndex) => (
                                                        <td key={valIndex}>
                                                            {val}
                                                        </td>
                                                    ))}
                                                </tr>
                                                <tr>
                                                    <td>Qty</td>
                                                    {itemQty?.qty?.map((val, valIndex) => (
                                                        <td key={valIndex}>
                                                            <input
                                                                type="text"
                                                                placeholder="0"
                                                                value={val}
                                                                onChange={(e) => handleItemQtyChange(e, valIndex)}
                                                                style={{ width: '40px' }}
                                                            />
                                                        </td>
                                                    ))}
                                                </tr>

                                            </tbody>
                                        </table>

                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleAddClick}>Add</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div>
                                        <div className="button-group">
                                            <button className="delete" onClick={handleRemoveMultiData}>Remove</button>
                                        </div>
                                        <table>
                                            <thead>
                                                <th>Sr.No.</th>
                                                <th>Item</th>
                                                <th>Total Qty.</th>
                                                <th>Total Material Qty.</th>
                                                <th>View</th>
                                            </thead>
                                            <tbody>
                                                {multiData?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td><input
                                                            type="checkbox"
                                                            checked={item.selected}
                                                            onChange={() => handleMultiDataSelection(index)}
                                                        />{" "}
                                                            {index + 1}
                                                        </td>
                                                        <td>{item.itemNm}</td>
                                                        <td>{item.totqty}</td>
                                                        <td>{item.totmtqty}</td>
                                                        <td><Preview className='cursor-pointer' onClick={() => handleViewClick(item)} /></td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td></td>
                                                    <td><b>Total</b></td>
                                                    <td>{formData.multot}</td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Grid>


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={multiData.length == 0}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default PartyInward;

